import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as nouvelleSouscriptionFormNames from "./nouvelleSouscriptionFormNames";

export const nouvelleSouscriptionValidationSchema = (roles) =>
  Yup.object().shape({
    [nouvelleSouscriptionFormNames.NOUVELLE_SOUSCRIPTION_EXERCICE_FORM_NAME]:
      Yup.string().typeError(FIELD_STRING).required(FIELD_REQUIRED),
    [nouvelleSouscriptionFormNames.NOUVELLE_SOUSCRIPTION_ACCEPT_TERMS_FORM_NAME]:
      Yup.bool().test(
        "mustAccept",
        "Veuillez Accepter les conditions générales.",
        (val) => roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") || val
      ),
  });
